import { IPartnerNavbarProps } from '../components/layout/navbar';
import { IFooterNavbarProps } from '../components/layout/footer/navbar';

export const PARTNER_BEACON_DESKTOP_LINKS: IPartnerNavbarProps['linksDesktop'] =
  [
    { label: 'Pricing', to: '/pricing' },
    { label: 'Estimate To Order', to: '/order' },
    { label: 'Resources', to: '/resources' },
    { label: 'Login', to: '/login' },
  ];
export const PARTNER_BEACON_MOBILE_LINKS: IPartnerNavbarProps['linksMobile'] = [
  { label: 'Sign Up', to: '/signup' },
  { label: 'Log In', to: '/login' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Estimate To Order', to: '/order' },
  { label: 'Resources', to: '/resources' },
];

export const PARTNER_BEACON_FOOTER_LINKS: IFooterNavbarProps['navbarItems'] = [
  { label: 'Pricing', to: '/pricing' },
  { label: 'Estimate To Order', to: '/order' },
  { label: 'Resources', to: '/resources' },
  { label: 'Log In', to: '/login' },
];
